export function isActiveZoneOnCloudflare(activeZone) {
  return activeZone.id !== undefined;
}



// WEBPACK FOOTER //
// src/selectors/activeZone.js